;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export default function Clipboard() {
  return (
    <svg width="119" height="151" viewBox="0 0 119 151" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_239_1422)">
        <path
          d="M97.9408 18.6167H110.748C114.285 18.6167 117.158 21.4704 117.158 24.9826V142.69C117.158 146.202 114.285 149.056 110.748 149.056H8.25178C4.71531 149.056 1.84192 146.202 1.84192 142.69V24.9826C1.84192 21.4704 4.71531 18.6167 8.25178 18.6167H21.0592"
          stroke="#455A63"
          strokeWidth="3"
          stroke-miterlimit="10"
        />
        <path
          d="M97.9408 31.3484H104.351V136.336H14.6494V31.3484H21.0592"
          stroke="#455A63"
          strokeWidth="3"
          stroke-miterlimit="10"
        />
        <path
          d="M81.9284 15.4339H72.3136C72.3136 8.40948 66.5791 2.71436 59.5061 2.71436C52.4332 2.71436 46.6987 8.40948 46.6987 15.4339H37.0839C31.7792 15.4339 27.4691 19.7022 27.4691 24.9826V34.5314H91.5309V24.9826C91.5309 19.7144 87.2331 15.4339 81.9161 15.4339H81.9284Z"
          stroke="#455A63"
          strokeWidth="3"
          stroke-miterlimit="10"
        />
        <path d="M59.5061 12.2629V18.6166" stroke="#455A63" strokeWidth="3" stroke-miterlimit="10" />
        <path
          d="M30.674 59.9825L38.8276 66.9216L49.8913 53.6167"
          stroke="#FFB400"
          strokeWidth="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30.674 85.4337L38.8276 92.3727L49.8913 79.0679"
          stroke="#FFB400"
          strokeWidth="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30.674 110.885L38.8276 117.824L49.8913 104.519"
          stroke="#FFB400"
          strokeWidth="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M65.9037 59.9827H88.326H65.9037Z"
          stroke="#455A63"
          strokeWidth="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M65.9037 85.4338H88.326H65.9037Z"
          stroke="#455A63"
          strokeWidth="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M65.9037 110.885H88.326H65.9037Z"
          stroke="#455A63"
          strokeWidth="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_239_1422">
          <rect width="119" height="150" fill="white" transform="translate(0 0.88501)" />
        </clipPath>
      </defs>
    </svg>
  );
}
